import { HighscoreService, HighscoreEntry } from "../services/HighscoreService";

export class HighscoreComponent extends HTMLElement {
    private highscoreData: HighscoreEntry[] = [];
    private highscoreService: HighscoreService = new HighscoreService();

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        void this.fetchHighscores();
    }

    private async fetchHighscores(): Promise<void> {
        try {
            this.highscoreData = await this.highscoreService.getHighscores();
            this.renderPopup();
        }
        catch (error) {
            console.error("Error with uploading Highscore data.", error);
            this.renderError();
        }
    }

    private formatTime(ms: number): string {
        const sec: number = Math.floor(ms / 1000) % 60;
        const min: number = Math.floor(ms / 60000) % 60;
        const hr: number = Math.floor(ms / 3600000);
        return `${hr}:${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
    }

    private renderPopup(): void {
        const currentUser: string | null = sessionStorage.getItem("username");
        const overlay: HTMLDivElement = document.createElement("div");
        overlay.className = "overlay";
        overlay.innerHTML = `
            <style>
                .overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.85);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                    backdrop-filter: blur(6px);
                    animation: fadeIn 0.3s ease-in-out;
                }

                .popup {
                    background-color: #0a0a1e;
                    padding: 30px;
                    border-radius: 16px;
                    box-shadow: 0 0 40px #00eaff;
                    max-height: 80vh;
                    max-width: 600px;
                    width: 90%;
                    overflow-y: auto;
                    color: #eaeaea;
                    font-family: "Orbitron", sans-serif;
                    animation: popupZoom 0.3s ease-out;
                }

                .close-btn {
                    padding: 8px 16px;
                    background-color: #00eaff;
                    color: black;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    font-weight: bold;
                    margin-bottom: 15px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                }

                th, td {
                    padding: 10px 16px;
                    border-bottom: 1px solid #333;
                    text-align: left;
                }

                th {
                    background-color: #2a2a40;
                    color: #ff00ff;
                    text-shadow: 0 0 4px #ff00ff;
                }

                tr.highlight {
                    background-color: rgba(169, 2, 230, 0.2);
                    font-weight: bold;
                    color: #ff00ff;
                }

                tr:hover {
                    background-color: #1a1a2e;
                }

                caption {
                    caption-side: top;
                    font-size: 1.6rem;
                    margin-bottom: 10px;
                    color: #00eaff;
                    text-shadow: 0 0 6px #00eaff;
                }

                @keyframes popupZoom {
                    0% { opacity: 0; transform: scale(0.8); }
                    100% { opacity: 1; transform: scale(1); }
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @media (max-width: 768px) {
        .popup {
            max-width: 90%;
            padding: 15px;
        }

        table {
            font-size: 0.8rem;
        }
    }

    @media (max-width: 480px) {
        .popup {
            max-width: 95%;
            padding: 10px;
        }

        table {
            font-size: 0.7rem;
        }
    }
            </style>
            <div class="popup">
                <button class="close-btn">Close</button>
                <table>
                    <caption>🏆 Highscores</caption>
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Username</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${this.highscoreData
            .sort((a, b) => a.time - b.time)
            .map((entry, index) => `
                                <tr class="${entry.username === currentUser ? "highlight" : ""}">
                                    <td>${index + 1}</td>
                                    <td>${entry.username}</td>
                                    <td>${this.formatTime(entry.time)}</td>
                                </tr>
                            `).join("")}
                    </tbody>
                </table>
            </div>
        `;

        const closeBtn: Element = overlay.querySelector(".close-btn")!;
        closeBtn.addEventListener("click", () => overlay.remove());
        this.shadowRoot?.append(overlay);
        //        document.body.appendChild(overlay);
    }

    private renderError(): void {
        alert("Error with uploading Highscore data.");
    }
}
